import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import { HashLink } from "react-router-hash-link";
import { BrowserRouter as Router } from "react-router-dom";
import { ArrowRightCircle } from "react-bootstrap-icons";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  return (
    <Router>
      <Navbar
        expand="md"
        data-Aos="fade-up"
        data-aos-delay="500"
        className={scrolled ? "scrolled" : ""}
      >
        <Container>
          <Navbar.Brand href="/" style={{ fontSize: 30, color: "wheat" }}>
            Eze Chinedu
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link
                href="#home"
                className={
                  activeLink === "home" ? "active navbar-link" : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("home")}
              >
                Home
              </Nav.Link>
              <Nav.Link
                href="#skills"
                className={
                  activeLink === "skills" ? "active navbar-link" : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("skills")}
              >
                Skills
              </Nav.Link>
              <Nav.Link
                href="#projects"
                className={
                  activeLink === "projects"
                    ? "active navbar-link"
                    : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("projects")}
              >
                Projects
              </Nav.Link>
            </Nav>
            <span className="navbar-text">
              <div className="social-icon">
                <a href="https://www.linkedin.com/in/david-chinedu-0429a2248">
                  <img src={navIcon1} alt="Nav-icon" />
                </a>
                <a href="https://www.facebook.com/profile.php?id=100087269012268">
                  <img src={navIcon2} alt="nav-icon" />
                </a>
                <a href="https://instagram.com/d_a_v_e_1_0_1?igshid=YzAwZjE1ZTI0Zg==">
                  <img src={navIcon3} alt="icon" />
                </a>
              </div>
              <HashLink to="#connect">
                <button
onClick={() => window.open("https://api.whatsapp.com/send?phone=09155660116&text=Hello David!%2C%20I%27m%20interested%20in%20your%20services.")}
                >
                  Let’s Connect <ArrowRightCircle size={25} />
                </button>
              </HashLink>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </Router>
  );
};
